import cloneDeep from 'lodash/cloneDeep';
import { EWhiteLabelFont } from '../white-label-fonts.enum';
import { TWhiteLabel, TWhiteLabelStore } from '../white-label.model';
import { getDefaultFontFamily } from './get-default-font-family';
import { getDefaultPanelColors } from './get-default-panel-colors';
import { getDefaultPrimaryColors } from './get-default-primary-colors';
import { hasCustomColors } from './has-custom-colors';
import { resolveIconActiveColorPanel } from './resolve-icon-active-color-panel';
import { resolveItemBgHover } from './resolve-item-bg-hover';
import { resolveStoredPrimary950 } from './resolve-stored-primary-950';

export function setWhiteLabel({
  data,
  accountId,
  oldWhiteLabel,
  isDefaultLabel,
}: {
  data: TWhiteLabel;
  accountId: string;
  oldWhiteLabel: TWhiteLabelStore;
  isDefaultLabel: boolean;
}): TWhiteLabelStore {
  const whiteLabelData: TWhiteLabel = cloneDeep(data);
  const whiteLabel = cloneDeep(oldWhiteLabel);

  if (Object.keys(whiteLabelData).length !== 0) {
    whiteLabel.created = !isDefaultLabel && hasCustomColors(whiteLabelData);

    // Fix to an old issue where the font family was not being set correctly
    if (whiteLabelData.fontFamily === ("'Source Sans Pro', sans-serif" as EWhiteLabelFont)) {
      whiteLabelData.fontFamily = EWhiteLabelFont.SOURCE_SANS_PRO;
    }

    if (!whiteLabelData.fontFamily) {
      whiteLabelData.fontFamily = getDefaultFontFamily();
    }

    const defaultPanelColors = getDefaultPanelColors();

    if (!whiteLabelData.panelAccent) {
      whiteLabelData.panelAccent = defaultPanelColors.panelAccent;
    }

    if (!whiteLabelData.panelBg) {
      whiteLabelData.panelBg = defaultPanelColors.panelBg;
    }

    if (!whiteLabelData.panelFont) {
      whiteLabelData.panelFont = defaultPanelColors.panelFont;
    }

    if (!whiteLabelData.panelFontHighlight) {
      whiteLabelData.panelFontHighlight = defaultPanelColors.panelFontHighlight;
    }

    if (!whiteLabelData.panelText) {
      whiteLabelData.panelText = defaultPanelColors.panelText;
    }

    if (!whiteLabelData.panelTextHover) {
      whiteLabelData.panelTextHover = defaultPanelColors.panelTextHover;
    }

    whiteLabelData.iconActiveColorPanel = resolveIconActiveColorPanel(data);

    if (!whiteLabelData.itemBorder) {
      whiteLabelData.itemBorder = defaultPanelColors.itemBorder;
    }

    whiteLabelData.itemBgHover = resolveItemBgHover(data);

    const defaultPrimaryColors = getDefaultPrimaryColors();

    if (!whiteLabelData.primary50) {
      whiteLabelData.primary50 = defaultPrimaryColors.primary50;
    }

    if (!whiteLabelData.primary75) {
      whiteLabelData.primary75 = defaultPrimaryColors.primary75;
    }

    if (!whiteLabelData.primary100) {
      whiteLabelData.primary100 = defaultPrimaryColors.primary100;
    }

    if (!whiteLabelData.primary200) {
      whiteLabelData.primary200 = defaultPrimaryColors.primary200;
    }

    if (!whiteLabelData.primary300) {
      whiteLabelData.primary300 = defaultPrimaryColors.primary300;
    }

    if (!whiteLabelData.primary400) {
      whiteLabelData.primary400 = defaultPrimaryColors.primary400;
    }

    if (!whiteLabelData.primary500) {
      whiteLabelData.primary500 = defaultPrimaryColors.primary500;
    }

    if (!whiteLabelData.primary600) {
      whiteLabelData.primary600 = defaultPrimaryColors.primary600;
    }

    if (!whiteLabelData.primary700) {
      whiteLabelData.primary700 = defaultPrimaryColors.primary700;
    }

    if (!whiteLabelData.primary800) {
      whiteLabelData.primary800 = defaultPrimaryColors.primary800;
    }

    if (!whiteLabelData.primary900) {
      whiteLabelData.primary900 = defaultPrimaryColors.primary900;
    }

    whiteLabelData.primary950 = resolveStoredPrimary950(whiteLabelData);
  }

  if (accountId !== undefined) {
    whiteLabel.accountId = accountId;
    whiteLabel.data = whiteLabelData;
  }

  return whiteLabel;
}
